import React from 'react';
import logoImage from '../../assets/logo.svg';
import { LogoEl } from './styles';

const Logo = () => {
    return <LogoEl src={logoImage} alt={'draftcloud.dev logo'} />
}

export default Logo;
